import { Component, OnInit, inject } from '@angular/core';
import { ArmDatService } from 'src/app/modules/user-profile/services/arm-data-service'; //'src/app/dashboard/services/arm-data-service';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { OrganizationsRolesData } from 'src/app/modules/user-profile/models/organizations-role';
import { EntitlementRequest } from 'src/app/modules/user-profile/models/entitlement-request';
import { RoleGroupEntitlementRequest } from 'src/app/modules/user-profile/models/role-group-entitlement-request';
import { ActivatedRoute } from '@angular/router';
import { CompareRolesDetailsComponent } from './compare-roles-details/compare-roles-details.component';
import { CompareRolesSummaryViewComponent } from './compare-roles-summary-view/compare-roles-summary-view.component';
import { MySummaryViewComponent } from './my-summary-view/my-summary-view.component';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-role-permission',
    templateUrl: './role-permission.component.html',
    styleUrls: [
        '../../../../../../../../src/assets/css/global-styles.scss',
        '../../../../../../../../src/assets/css/ds-core.css',
        '../../../../../../../../src/assets/css/ds-button.css',
        '../../../../../../../../src/assets/css/ds-card.css',
        '../../../../../../../../src/assets/css/ds-form.css',
        '../../../../../../../../src/assets/css/ds-modal.css',
        '../../../../../../../../src/assets/css/ds-step-indicator.css',
        '../../../../../../../../src/assets/css/ds-tabs.css',
        '../../../../../../../../src/assets/css/ds-tile.css',
        './role-permission.component.scss',
    ],
    imports: [
    NgxSpinnerModule,
    FormsModule,
    MySummaryViewComponent,
    CompareRolesSummaryViewComponent,
    CompareRolesDetailsComponent
]
})
export class RolePermissionComponent implements OnInit {
  private armDataService = inject(ArmDatService);
  private spinner = inject(NgxSpinnerService);
  private activatedRoute = inject(ActivatedRoute);

  mydetailsview = [];
  orgId: string;
  isSelected: any;
  systemApplications: any;
  systemName: string;
  userRoleObj: any;
  currentApplication: any;
  organizationsRoles: OrganizationsRolesData;
  selectedOrganization: any;
  internalSummarRoles: any;
  externalSummarRoles: any;
  orgNameObj: any;
  applicationKey = '';
  summaryTabData: any;
  entitlementRequest: EntitlementRequest;

  shoulddisplay = true;
  ngOnInit(): void {
    this.systemName = '';
    this.isSelected = 'summary-tab';

    this.getOrgId();
    this.bindSystemApplications();

    let orgKey = sessionStorage.getItem('orgKey');
    this.organizationRolesResponse(orgKey);
  }
  setMySummaryViewData(orgKey, appKey, sysKey) {
    this.entitlementRequest = {
      orgKey: orgKey, // '6265',
      appKey: appKey, //'120',
      sysKey: sysKey, // '4',
    };

    this.armDataService
      .entitelmentGroups$(this.entitlementRequest)
      .subscribe((response) => {
        this.summaryTabData = response;
      });
  }

  renderTab(event) {
    this.isSelected = event.target.id;
  }

  setCompareMySummaryViewData(orgKey, appKey) {
    var roleGroupEntitlementRequestInt: RoleGroupEntitlementRequest = {
      orgKey: orgKey,
      appKey: appKey,
      roleType: '1',
    };
    var roleGroupEntitlementRequestExt: RoleGroupEntitlementRequest = {
      orgKey: orgKey,
      appKey: appKey,
      roleType: '2',
    };

    this.armDataService
      .roleGroupEntitelmentGroups$(roleGroupEntitlementRequestInt)
      .subscribe((response) => {
        this.internalSummarRoles = response;
      });

    this.armDataService
      .roleGroupEntitelmentGroups$(roleGroupEntitlementRequestExt)
      .subscribe((response) => {
        this.externalSummarRoles = response;
      });
  }
  getOrgId() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.orgId = params.get('organizationId');
    });
  }

  organizationRolesResponse(selectedOrganization) {
    this.armDataService
      .organizatationRolesByKey$(selectedOrganization)
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.userRoleObj = res;
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  onChangeApplicationDropdown(appKey) {
    let orgKey = sessionStorage.getItem('orgKey');
    let systemKey = sessionStorage.getItem('systemKeyRoles');

    sessionStorage.setItem('applicationKey', appKey);
    this.setMySummaryViewData(orgKey, appKey, systemKey);
    this.setCompareMySummaryViewData(orgKey, appKey);
    this.getEntitlements();
  }

  bindSystemApplications() {
    this.spinner.show();

    let orgKey = sessionStorage.getItem('orgKey');
    this.armDataService.SystemApplicationsByOrg$(orgKey).subscribe(
      (SystemApplicationData: any) => {
        this.spinner.hide();
        let sysKey = Number(sessionStorage.getItem('systemKey'));
        let appKey = Number(sessionStorage.getItem('systemKey'));
        let appName = sessionStorage.getItem('systemName');
        this.systemName = appName;
        this.currentApplication = SystemApplicationData?.filter(
          (r) => r.system.systemKey == sysKey
        )[0]?.applications;
        // Default setting yhe Value Application DropDown.
        this.applicationKey = this.currentApplication[0]?.applicationKey;
        this.onChangeApplicationDropdown(this.applicationKey);
      },
      (error) => {
        this.spinner.hide();
      }
    );

    orgKey = sessionStorage.getItem('orgKey');
    this.armDataService.SystemApplicationsByOrg$(orgKey).subscribe((data) => {
      // Testing Purpose Added console, Later will remove
      this.systemApplications = data;
    });
  }

  onSelect(event) {
    if (event.id === 'mydetails') {
      this.spinner.show();
      this.getEntitlements();
    } else if (event.id === 'compareRoles') {
    }
  }

  getEntitlements() {
    let orgKey = sessionStorage.getItem('orgKey');
    let systemKey = sessionStorage.getItem('systemKeyRoles');
    let applicationKey = sessionStorage.getItem('applicationKey');
    this.armDataService
      .getEntitlements$(orgKey, systemKey, applicationKey)
      .subscribe(
        (data: any[]) => {
          this.spinner.hide();
          this.mydetailsview = data;
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }
}
